import { Stack } from '@mui/material';
import { Typography, InfoBox } from '@occc/ui-design-system';

import { InlineButton } from './InlineButton';
import { FullWidthButton } from './FullWidthButton';
import { separateEveryThousandByComma } from '../../../lib/numbers';

type AudienceDraftSizeContentProps = {
  displayCount: number;
  isLoading: boolean;
  isCalculating: boolean;
  showInfoMessage: boolean;
  neverCalculated: boolean;
  hasCalculatedCount: boolean;
  onCalculateOrRefresh: () => void;
};

export const AudienceDraftSizeContent = ({
  displayCount,
  isLoading,
  isCalculating,
  showInfoMessage,
  neverCalculated,
  hasCalculatedCount,
  onCalculateOrRefresh,
}: AudienceDraftSizeContentProps) => {
  return (
    <Stack spacing={2}>
      <Stack display={'flex'} alignItems={'center'} direction={'row'} spacing={1}>
        {!neverCalculated && (
          <Typography component='span' variant='h4'>
            {separateEveryThousandByComma(displayCount)}
          </Typography>
        )}

        <InlineButton
          isCalculating={isCalculating}
          hasCalculatedCount={hasCalculatedCount}
          isLoading={isLoading}
          onCalculateOrRefresh={onCalculateOrRefresh}
        />
      </Stack>

      <FullWidthButton
        isCalculating={isCalculating}
        neverCalculated={neverCalculated}
        isLoading={isLoading}
        onCalculateOrRefresh={onCalculateOrRefresh}
      />

      {showInfoMessage && (
        <InfoBox type='info'>
          <Typography variant='body2'>
            Please note that it may take up to 1 hour to calculate the projected audience size
          </Typography>
        </InfoBox>
      )}
    </Stack>
  );
};
